export class unitRequiest{
    unitId:number;
    locationId?:number
    constructor( unitId:number,
        locationId?:number){
            this.unitId=unitId;
            this.locationId=locationId;
    }
}